import { Flex, Loader } from '@mantine/core'
import { Suspense, useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuth } from 'src/features/auth'
import { SkalxProvider } from 'src/features/auth/oidc/SkalxProvider'

import { paths } from './paths'

export const LoadingFallback = () => (
  <Flex h="100vh" align="center" justify="center">
    <Loader size="lg" />
  </Flex>
)

export const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname])

  return null
}

export const ProtectedOutlet = () => {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) return <LoadingFallback />

  if (!isAuthenticated) {
    const returnTo = encodeURIComponent(location.pathname + location.search)

    return <Navigate to={`${paths.auth.login}?return=${returnTo}`} replace />
  }

  return <Outlet />
}

export const RootLayout = () => (
  <SkalxProvider>
    <Suspense fallback={<LoadingFallback />}>
      <Outlet />
    </Suspense>
  </SkalxProvider>
)
